<template>
<el-container id="home-main">
  <div class="home-center">
    <publicHeader @hotelDetailCurrency="hotelDetailCurrency" @hotelLanguage="hotelLanguage"></publicHeader>
    <div class="home-rotation">
      <div class="container container-pc" ref="containerDiv" v-if="homeMobile === 0">
          <!-- 先把第一张图片显示出来 -->
          <img class="on" src="https://res.roompai.com/static/img/rotation/photo1.jpg" />
          <img src="https://res.roompai.com/static/img/rotation/photo2.jpg" />
          <img src="https://res.roompai.com/static/img/rotation/photo3.jpg" />
          <img src="https://res.roompai.com/static/img/rotation/photo4.jpg" />
          <img src="https://res.roompai.com/static/img/rotation/photo5.jpg" />
      </div>
      <div class="container container-mobile" ref="containerDiv" v-if="homeMobile === 1">
          <!-- 先把第一张图片显示出来 -->
          <img class="on" src="/static/img/rotation/photo_mobile1.png" />
          <img class="on" src="/static/img/rotation/photo_mobile2.png" />
      </div>
    </div>
    <div class="home-search">
      <!-- 焦点 -->
      <!--
      <div class="left" @click="rotationLeftClick" style="opacity: 0.5;"> <img src="/static/img/home/left-rotation.png" alt=""> </div>
      <div class="right" @click="rotationRightClick" style="opacity: 0.5;"> <img src="/static/img/home/right-rotation.png" alt=""> </div>
      -->
      <div class="rotation-button">
        <div class="rotation-ul container-pc" style="width: 163px;margin: 0 auto;" v-if="homeMobile === 0">
          <ul>
              <li class="active" @click="rotationButtonClick(0)"></li>
              <li @click="rotationButtonClick(1)"></li>
              <li @click="rotationButtonClick(2)"></li>
              <li @click="rotationButtonClick(3)"></li>
              <li @click="rotationButtonClick(4)"></li>
          </ul>
        </div>
        <div class="rotation-ul container-mobile" style="width: 163px;margin: 0 auto; display: none;" v-if="homeMobile === 1">
          <ul>
              <li class="active" @click="rotationButtonClick(0)"></li>
              <li @click="rotationButtonClick(1)"></li>
          </ul>
        </div>
      </div>
      <div class="home-slogan-search">
        <div class="home-slogan">
          <p class="home-slogan-one">Make room for your</p>
          <p class="home-slogan-two">passion and inspiration…</p>
        </div>
        <div class="home-search-frame">
          <!--
          <el-input size="large" placeholder="目的地" class="home-region" autocomplete="off" type="text" clearable v-model="input_region" > </el-input>
          <el-date-picker v-model="input_date" type="daterange" prefix-icon="input-date-icon" start-placeholder="开始日期" end-placeholder="结束日期"  class="input-date" ></el-date-picker>
          <el-select size="large" placeholder="" class="input-person" autocomplete="off" type="text" clearable v-model="input_person" > </el-select>
          -->
          <div class="location-search location-search-pc">
              <div class="hotellist-region el-input el-input--large el-input--suffix" style="float: left;margin-right:0.45%;margin-left:1.82%;">
                <div class="mainMask" v-if="frameRegionMustDialog" @click="frameRegionMustDialog = !frameRegionMustDialog"></div>
                <div class="mainMask" v-if="noDestinationtDialog" @click="noDestinationtDialog = !noDestinationtDialog"></div>
                <el-popover placement="top" class="inline-input-alert" trigger="manual" visible-arrow="true" :content="$t('enterNameOfDestinationOrProperty')" v-model="frameRegionMustDialog" :append-to-body="false">
                </el-popover>
                <el-popover placement="top" class="inline-input-alert" trigger="manual" visible-arrow="true" :content="$t('noDestination')" v-model="noDestinationtDialog" :append-to-body="false">
                </el-popover>
                <el-autocomplete class="inline-input" popper-class="my-autocomplete" v-model="region" :fetch-suggestions="querySearch" :placeholder="$t('goingTo')" @select="handleRegionSelect" @input="loadAll" :popper-append-to-body="false" slot="reference" ref="regionInput" placement="bottom-start">
                  <template slot-scope="{ item }">
                    <div style="width:8%;float: left;text-align:center;" >
                      <div v-if="item.type == 'location'" class="locationClass"></div>
                      <div v-if="item.type == 'hotel'" class="hotelClass"></div>
                    </div>
                    <div style="width:82%;float:left;display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left;text-indent: 0.5rem;">
                      <div class="name">
                        <span v-html="getLanguageHtml(item, 'value')"></span>
                      </div>
                      <span class="addr" style="display: block;line-height: 25px;">
                        <span v-html="getLanguageHtml(item, 'address')"></span>
                      </span>
                    </div>
                  </template>
                </el-autocomplete>
              </div>

              <div class="hotellist-date-all" @click="dateSearchShow($event)" style="float: left;margin-right:0.45%;" data-index="date-pc">
                <div class="el-date-editor el-range-editor el-input__inner hotellist-date el-date-editor--daterange" style="padding:0px;" :class="{'hotellist-date-show':hotelDateSearchShow}" data-index="date-pc">
                  <i class="el-input__icon el-range__icon input-date-icon" style="background-position: center center;padding: 0px 10px;"  data-index="date-pc"></i>
                  <div class="hotellist-date-start" :class="{'hotellist-date-start-left': language === 'en'}" data-index="date-pc">
                    <div class="hotellist-date-start-date" data-index="date-pc">{{checkDateWeek.date[0]}}</div>
                    <div class="hotellist-date-start-week" data-index="date-pc">{{checkDateWeek.week[0]}}</div>
                  </div>
                  <div class="hotellist-date-line" data-index="date-pc"><img src="/static/img/home/date-line-bold.png" alt="" data-index="date-pc"></div>
                  <div class="hotellist-date-end" data-index="date-pc">
                    <div class="hotellist-date-end-date" data-index="date-pc">{{checkDateWeek.date[1]}}</div>
                    <div class="hotellist-date-end-week" data-index="date-pc">{{checkDateWeek.week[1]}}</div>
                  </div>
                </div>
                <div data-index="date-pc">
                  <el-date-picker v-model="checkDate" type="daterange" prefix-icon="input-date-icon" :start-placeholder="$t('startIn')" :end-placeholder="$t('endOut')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="hotellist-date" popper-class="hotellist-date-time-show" :clearable="dateClearable" ref="hiddenDatePicker" :append-to-body="false" :picker-options="pickerOptions" style="position: absolute;height: 0px; background: rgb(0,0,0,0);bottom: 5px; border: 0px;" data-index="date-pc"></el-date-picker>
                </div>
              </div>

              <div class="select-person" style="float: left;margin-right:0.45%;">
                <div class="hotellist-person el-select--large" @click="showPerson($event)" data-index="person-pc">
                  <div class="el-input el-input--large el-input--suffix" data-index="person-pc">
                    <div class="person-inner" :class="{'showPersonBorder':showPersonInfo}" data-index="person-pc">
                      <span class="personText" data-index="person-pc">
                        <span data-index="person-pc">
                          {{personInfo}}
                          <span v-if="personInfo<=1" data-index="person-pc">{{$t('adult')}}</span>
                          <span v-else data-index="person-pc">{{$t('adults')}}</span>
                        </span>
                        <span v-if="childNum > 0" data-index="person-pc">
                          , {{childNum}}
                          <span v-if="childNum<=1" data-index="person-pc">{{$t('child')}}</span>
                          <span v-else data-index="person-pc">{{$t('children')}}</span>
                        </span>
                      </span>
                      <span class="roomText" data-index="person-pc">
                        {{roomInfo}}
                        <span v-if="roomInfo<=1" data-index="person-pc">{{$t('room')}}</span>
                        <span v-else data-index="person-pc">{{$t('rooms')}}</span>
                      </span>

                      <div class="el-input__suffix" data-index="person-pc">
                        <div class="el-input__suffix-inner" data-index="person-pc"  style="height: 100%;line-height: 50px;">
                          <i class="el-select__caret el-input__icon el-icon-arrow-down" style="vertical-align: super;" data-index="person-pc"></i>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="personInfo" v-show="showPersonInfo" data-index="person-pc">
                  <div class="personnum" data-index="person-pc">
                    <button class="personLessno" :class="{'personLess': roomLessDo}" @click="roomLess" data-index="person-pc"></button>
                    <span style="width: 38%;text-align: left;margin-left: 25px;" data-index="person-pc">
                      <span class="personSpan" data-index="person-pc">{{roomNum}}</span>
                      <span class="spantext" data-index="person-pc">
                        <span v-if="roomNum<=1" data-index="person-pc">{{$t('room')}}</span>
                        <span v-else data-index="person-pc">{{$t('rooms')}}</span>
                      </span>
                    </span>
                    <button class="personAdd" @click="roomAdd" :class="{'personAddno':roomAddNoDo}" data-index="person-pc"></button>
                  </div>
                  <div class="personnum" data-index="person-pc">
                    <button class="personLessno" :class="{'personLess': adultLessDo}" @click="adultLess" data-index="person-pc"></button>
                    <span style="width: 38%;text-align: left;margin-left: 25px;" data-index="person-pc">
                      <span class="personSpan" data-index="person-pc">{{adultNum}}</span>
                      <span class="spantext" data-index="person-pc">
                        <span v-if="adultNum<=1" data-index="person-pc">{{$t('adult')}}</span>
                        <span v-else data-index="person-pc">{{$t('adults')}}</span>
                      </span>
                    </span>
                    <span class="personAdd" @click="adultAdd" data-index="person-pc"></span>
                  </div>
                  <div class="personnum" data-index="person-pc">
                    <button class="personLessno" :class="{'personLess': childLessDo}" @click="childLess" data-index="person-pc"></button>
                    <span style="width: 38%;text-align: left;margin-left: 25px;" data-index="person-pc">
                      <span class="personSpan" data-index="person-pc">{{childNum}}</span>
                      <span class="spantext" data-index="person-pc">
                        <span v-if="childNum<=1" data-index="person-pc">{{$t('child')}}</span>
                        <span v-else data-index="person-pc">{{$t('children')}}</span>
                      </span>
                    </span>
                    <span class="personAdd" @click="childAdd" :class="{'personAddno':childAddNoDo}" data-index="person-pc"></span>
                  </div>
                  <div class="childinfo" style="width:100%;margin-top:-10%;" v-show="showChildInfo" data-index="person-pc">
                    <div style="text-align:center" v-html="$t('childAge')" v-if="childNum<=1" data-index="person-pc"></div>
                    <div style="text-align:center" v-html="$t('childrenAges')" v-else data-index="person-pc"></div>
                    <div v-for="(n, nums) in childNum" :key="nums" data-index="person-pc">
                      <div v-if="selecteds[nums] == undefined">
                        <el-select class="selectOld" value="<1" placeholder="-" data-index="person-pc" @change="updateChildSelect(nums, $event)">
                          <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                        </el-select>
                      </div>
                      <div v-else>
                        <el-select class="selectOld" v-model="selecteds[nums]" placeholder="-" data-index="person-pc">
                          <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <el-button class="input_button" id="inputButtonPc" @click="searchList" style="margin-reight:1.82%;">{{$t('search')}}</el-button>
          </div>
          <div class="location-search location-search-moblie" ref="locationSearchMoblie">
              <div class="hotellist-region el-input el-input--large el-input--suffix" style="margin: 20px 0px 5px;">
                <input type="text" autocomplete="off" :placeholder="$t('goingTo')" ref="homeRegion" :value="region" class="el-input__inner home-search-text homeInputRegion" @click="addrSearch = true" readonly>
              </div>
              <div class="select-date"  @click="dateSearch = true"  style="margin: 5px 0px 5px;">
                  <div class="hotellist-date-mobile el-select--large">
                      <div class="date-inner">
                          <div class="date-inner-start">
                            <div class="date-inner-check-img"></div>
                            <div class="date-inner-check-info">
                              <div class="date-inner-check-str">{{$t('checkIn')}}</div>
                              <div class="date-inner-check-date home-search-text"><span v-if="language === 'zh'">{{checkDateWeek.date[0]}} {{checkDateWeek.week[0]}}</span><span v-else>{{checkDateWeek.week[0]}}, {{checkDateWeek.date[0]}}</span></div>
                            </div>
                          </div>
                          <div class="date-inner-division"></div>
                          <div class="date-inner-end">
                            <div class="date-inner-check-img"></div>
                            <div class="date-inner-check-info">
                              <div class="date-inner-check-str">{{$t('checkOut')}}</div>
                              <div class="date-inner-check-date home-search-text"><span v-if="language === 'zh'">{{checkDateWeek.date[1]}} {{checkDateWeek.week[1]}}</span><span v-else>{{checkDateWeek.week[1]}}, {{checkDateWeek.date[1]}}</span></div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="select-person"  @click="personSearch = true" style="margin: 5px 0px 5px;">
                <div class="hotellist-person el-select--large">
                  <div class="el-input el-input--large el-input--suffix">
                    <div class="person-inner" :class="{'showPersonBorder':showPersonInfo}">
                      <span class="personText home-search-text">
                        <span style="display: inline-block;height: 100%;line-height: 46px;vertical-align: top;float:left;">
                          {{roomInfo}} <span v-if="roomInfo<=1">{{$t('room')}}</span><span v-else>{{$t('rooms')}}</span>
                        </span>
                        <span style="display: inline-block;height: 100%;line-height: 46px;vertical-align: top;float:left;margin:0px 1px;">
                          ·
                        </span>
                        <span style="display: inline-block;height: 100%;line-height: 46px;vertical-align: top;float:left;">
                          {{personInfo}} <span v-if="personInfo<=1">{{$t('adult')}}</span><span v-else>{{$t('adults')}}</span>
                        </span>

                        <span v-if="childNum >= 1" style="display: inline-block;height: 100%;line-height: 46px;vertical-align: top;float:left;margin:0px 1px;">
                          ·
                        </span>
                        <span v-if="childNum >= 1" style="display: inline-block;height: 100%;line-height: 46px;vertical-align: top;float:left;">
                          {{childNum}} <span v-if="childNum<=1">{{$t('child')}}</span><span v-else>{{$t('children')}}</span>
                        </span>
                      </span>
                    </div>
                    <div class="el-input__suffix">
                      <div class="el-input__suffix-inner">
                        <i class="el-select__caret el-input__icon el-icon-arrow-down" style="vertical-align: super;"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-button class="input_button input_button_pc" @click="searchListMobile" style="margin: 5px 0px 20px;">{{$t('search')}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="clear:both;height: 60px;"></div>
  <div class="home-collection" v-show="collectShow">
    <div class="home-collection-center">
      <h3> {{$t('myFavorite')}} </h3>
      <div class="home-collection-pc">
        <el-row>
          <el-col :span="4" class="row-col" v-for="(value, key) in myCollectList" :key="key">
            <el-card style="height:345px;" :class="{'marginnone': key === 5 || key === '5'}">
              <div class="home-img">
                <span style="cursor: pointer;" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                  <div class="picinfo" v-if="value.pic !== ''">
                    <img :src="value.pic" class="hotel-image">
                  </div>
                  <div class="picinfo" v-else>
                    <img :src="value.dpic" class="hotel-image">
                    <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                  </div>
                </span>
                <svg @click="collect(value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                  <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                </svg>
                <!-- <div :class="'home-love-'+value.islike" @click="collect(value.hotelid, value.islike)"></div> -->
              </div>
              <div class="hotel-infos" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                <span class="hotel-name">
                  <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                    <span>{{value.hotelname_short}}</span>
                  </el-tooltip>
                </span>
                <span class="hotel-star">
                  <b style="margin-right: 3px;" v-for="n in parseInt(value.star)" :key="n">
                    <img style="width:15px;height:15px;" src="/static/img/star.png">
                  </b>
                  <b style="margin-left: -3px;" v-if="value.star_decimal === 1">
                    <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                  </b>
                </span>
                <span class="hotel-addr" v-if="language === 'en'">
                  <el-tooltip :content="value.hoteladdress" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                    <span>{{value.hoteladdress_short}}</span>
                  </el-tooltip>
                </span>
                <span class="hotel-addr" v-else>
                  <el-tooltip :content="value.hoteladdress_zh" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                    <span>{{value.hoteladdress_short_zh}}</span>
                  </el-tooltip>
                </span>
                <span class="hotel-br"></span>
                <div class="hotel-price">
                  <span v-if="value.price > 0">
                    <span style="font-size:10px; font-weight:400;display: inline-block;">{{resultCurrency}}</span> {{value.price}}
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="home-collection-mobile">
        <el-row>
          <el-col :span="12" class="row-col" v-for="(value, key) in myCollectList" :key="key">
            <el-card :class="{'marginnone': key === 5 || key === '5'}">
              <div class="home-img">
                <span style="cursor: pointer;">
                  <div class="picinfo" v-if="value.pic !== ''">
                    <img :src="value.pic" class="hotel-image">
                  </div>
                  <div class="picinfo" v-else>
                    <img :src="value.dpic" class="hotel-image">
                    <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                  </div>
                </span>
                <svg @click="collect(value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                  <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                </svg>
                <!-- <div :class="'home-love-'+value.islike" @click="collect(value.hotelid, value.islike)"></div> -->
              </div>
              <div class="hotel-infos" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                <span class="hotel-name">
                  <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                    <span>{{value.hotelname_short}}</span>
                  </el-tooltip>
                </span>
                <span style="height:20px;"></span>
                <div class="hotel-price">
                  <span v-if="value.price > 0">
                    <span style="font-size:10px; font-weight:400;display: inline-block;">{{resultCurrency}}</span> {{value.price}}
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>

  <el-dialog :visible.sync="frameRegionMustDialogMobile" :show-close="noGotoClose" class="nogoto-margin" width="90%" top="35vh">
    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('enterNameOfDestinationOrProperty')}}</div>
    <div @click="frameRegionMustDialogMobile = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
      {{$t('close')}}
    </div>
  </el-dialog>
  <el-dialog :visible.sync="noDestinationtDialogMobile" :show-close="noGotoClose" class="nogoto-margin" width="90%" top="35vh">
    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('noDestination')}}</div>
    <div @click="noDestinationtDialogMobile = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
      {{$t('close')}}
    </div>
  </el-dialog>
  <publicSearch :addrSearch="addrSearch" :regionSearch="region" @getSonRegion="getSonRegion" @closepop="closepopEven"></publicSearch>
  <publicSearch :dateSearch="dateSearch" :checkDateSearch="checkDate" :addrDateTime="addrDateTime" @getSonDate="getCheckDate" @closepop="closepopEven"></publicSearch>
  <publicSearch :personSearch="personSearch" :selectedsSearch="selecteds" :roomNumSearch="roomNum" :adultNumSearch="adultNum" :childNumSearch="childNum" @getSonPerson="getSonPerson" @closepop="closepopEven"></publicSearch>
  <publicFooter :languageSet="language"></publicFooter>
  <NoPayOrderPop></NoPayOrderPop>
</el-container>
</template>

<script scoped>
import { myCollect, doCollect } from '@/request/collect.js'
import { getHotelList } from '@/request/search.js'
import publicFooter from '@/components/public/publicFooter'
import publicSearch from '@/components/public/publicSearch'
import publicHeader from '@/components/public/publicHeader'
import NoPayOrderPop from '@/components/order/module/NoPayOrderPop'
export default {
  name: 'Home',
  components: {
    publicFooter,
    publicHeader,
    publicSearch,
    NoPayOrderPop
  },
  props: [],
  data () {
    return {
      homeMobile: 0,
      homeWidth: 0,
      input_region: '',
      input_person: '',
      addrSearch: false,
      dateSearch: false,
      personSearch: false,
      noDestinationtDialog: false,
      noDestinationtDialogMobile: false,
      frameRegionMustDialog: false,
      frameRegionMustDialogMobile: false,
      showClo: true,
      activeIndex: 0,
      selected: '',
      selecteds: [],
      checkDate: [],
      checkDateWeek: {'date': ['', ''], 'week': ['', '']},
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      personInfo: '2',
      roomInfo: '1',
      showPersonInfo: false,
      roomLessDo: false,
      roomAddNoDo: false,
      adultLessDo: true,
      childLessDo: false,
      childAddNoDo: false,
      childOld: this.common.childOld,
      showChildInfo: false,
      restaurants: {},
      region: '',
      region_select: '',
      region_value: '',
      search_json: {},
      regions: {
        '7980': { 'id': '7980', 'type': 'location', 'value': '纽约，美国', 'address': '纽约，美国', 'country': '美国', 'city': '纽约' },
        '767978': { 'id': '767978', 'type': 'hotel', 'value': '大西洋城赌场度假酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '743455': { 'id': '743455', 'type': 'hotel', 'value': '金块酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '438276': {'id': '438276', 'type': 'hotel', 'value': '纽约曼哈顿时代广场酒店(The Manhattan at Times Square Hotel New York)', 'address': '纽约，美国', 'country': '美国', 'city': '纽约'}
      },
      timeout: null,
      myCollectList: [],
      collectShow: false,
      dateClearable: false,
      pickerOptions: '',
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      triggerOnFocus: true,
      hotelDateSearchShow: false,
      resultCurrency: '',
      noGotoClose: false,
      star: '',
      end: '',
      addrDateTime: '',
      source: 'roompai',
      conver: ''
    }
  },
  beforeCreate () {
  },
  created: function () {
    localStorage.removeItem('LoginWebsiteAddress')

    // 获取当前日期
    let d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth()
    var tian = d.getDate()
    var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
    var startDate = tian
    var endDate = tian + 1
    var startMonth = month
    var endMonth = month
    var startYear = year
    var endYear = year
    if (startDate > dayNum) {
      startDate = parseInt(startDate) - parseInt(dayNum)
      startMonth += 1
    }
    if (endDate > dayNum) {
      endDate = parseInt(endDate) - parseInt(dayNum)
      endMonth += 1
    }
    if (startMonth >= 12) {
      startMonth = 0
      startYear += 1
    }
    if (endMonth >= 12) {
      endMonth = 0
      endYear += 1
    }
    var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
    var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
    var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
    var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
    this.checkDate.push(startYear + '-' + monthStartSelect + '-' + startDateSelect)
    this.checkDate.push(endYear + '-' + monthEndSelect + '-' + endDateSelect)

    // 默认日期禁止
    var time = year + '-' + monthStartSelect + '-' + startDate + ' 00:00:00'
    this.pickerOptions = {
      disabledDate (date) {
        return date.getTime() < new Date(time).getTime()
      }
    }
  },
  mounted: function () {
    // 存储来源
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
    if (this.common.linkQuerys.conver === 1 || this.common.linkQuerys.conver === '1') {
      this.conver = this.common.linkQuerys.conver
    }
    var date1 = new Date()
    date1.setDate(date1.getDate() + 1)
    var date2 = new Date(date1)
    date2.setDate(date1.getDate() + 1)
    this.start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
    this.end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
    // 轮播图 自动循环
    this.$nextTick(function () {
      window.setInterval(this.rotationRightClick, 20000)
    })
    this.loadAll('', 1)
    this.getMyCollect()

    // 保留选择的目的地 (默认搜索的是空)
    sessionStorage.setItem('regionSel', '{}')

    // 语言
    var that = this
    setInterval(function () {
      that.language = that.common.languageSet(that)
    }, 200)

    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)

    // 获取屏幕尺寸
    this.homeWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.homeWidth = document.body.clientWidth
      })()
    }
  },
  watch: {
    checkDate: function (n, o) {
      this.checkDateWeek = {}
      this.checkDate = n
      // this.pickerOptions = {
      //   onPick: ({maxDate, minDate}) => {
      //     this.pickDate = n
      //   }
      // }
      let startDate = new Date(n[0].replace(/-/g, '/'))
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(n[1].replace(/-/g, '/'))
      // 如果开始日期和结束日期选择了同一天，则结束日期=开始日期+1天.
      if (n[0] === n[1]) {
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }
        console.log('开始日期与结束日期选择了同一天，重置结束日期')
        console.log(endDate)
      }
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
      let endW = endDate.getDay()

      // 显示
      if (this.checkDate['1'] !== undefined) {
        this.checkDate['1'] = endY + '-' + endM + '-' + endD
      }

      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (this.language === 'en') {
        // Sep 15, 2022
        if (this.common.isMobile() === false) {
          startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
          endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
          startwkstr = this.common.weekPcEn[startW]
          endwkstr = this.common.weekPcEn[endW]
        } else {
          startYmd = this.common.monthEn[startMen] + ' ' + startD
          endYmd = this.common.monthEn[endMen] + ' ' + endD
          startwkstr = this.common.weekEn[startW]
          endwkstr = this.common.weekEn[endW]
        }
      } else {
        if (this.common.isMobile() === false) {
          startYmd = startY + '年' + startM + '月' + startD + '日'
          endYmd = endY + '年' + endM + '月' + endD + '日'
          startwkstr = this.common.weekZh[startW]
          endwkstr = this.common.weekZh[endW]
        } else {
          startYmd = startM + '月' + startD + '日'
          endYmd = endM + '月' + endD + '日'
          startwkstr = this.common.weekMobileZh[startW]
          endwkstr = this.common.weekMobileZh[endW]
        }
      }

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)

      this.hotelDateSearchShow = false
      // console.log(this.checkDate)
    },
    language: function (n, o) {
      this.checkDateWeek = {}

      let startDate = new Date(this.checkDate[0])
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(this.checkDate[1])
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
      let endW = endDate.getDay()

      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (this.language === 'en') {
        // Sep 15, 2022
        if (this.common.isMobile() === false) {
          startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
          endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
        } else {
          startYmd = this.common.monthEn[startMen] + ' ' + startD
          endYmd = this.common.monthEn[endMen] + ' ' + endD
        }
        startwkstr = this.common.weekEn[startW]
        endwkstr = this.common.weekEn[endW]
      } else {
        if (this.common.isMobile() === false) {
          startYmd = startY + '年' + startM + '月' + startD + '日'
          endYmd = endY + '年' + endM + '月' + endD + '日'
          startwkstr = this.common.weekZh[startW]
          endwkstr = this.common.weekZh[endW]
        } else {
          startYmd = startM + '月' + startD + '日'
          endYmd = endM + '月' + endD + '日'
          startwkstr = this.common.weekMobileZh[startW]
          endwkstr = this.common.weekMobileZh[endW]
        }
      }

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)

      this.language = n
      // 刷新页面
      this.getMyCollect() // 我的收藏

      // 搜索框中 中英文转换
      if (this.region !== '') {
        var regionSelJson = sessionStorage.getItem('regionSel')
        var regionSelArr = JSON.parse(regionSelJson)
        if (n === 'en') {
          this.region = regionSelArr.value_en
        } else {
          this.region = regionSelArr.value_zh
        }
      }
    },
    homeWidth: function (n, o) {
      if (n <= 992) {
        this.homeMobile = 1
      } else {
        this.homeMobile = 0
      }
    },
    currency: function (newCur, oldCur) {
      this.getMyCollect()
    },
    addrDateTime: function (newTime, oldTime) {
      var addrTime = newTime + ' 00:00:00'
      this.pickerOptions = {
        disabledDate (date) {
          return date.getTime() < new Date(addrTime).getTime()
        }
      }

      const newdate = new Date(newTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]

      this.checkDate = []
      this.checkDate.push(newTime)
      this.checkDate.push(newDateStr)
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    hotelLanguage (language) {
      /* this.restaurants = '' */
      this.region = ''
      this.frameRegionMustDialog = false
      this.noDestinationtDialog = false
    },
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      var typeLan = ''
      if (['value'].includes(type)) {
        var valueHtml = ''
        if (data['type'] !== 'location') {
          if (getLanguage === 'zh') {
            valueHtml = data[type + '_zh'] + ' (' + data[type + '_en'] + ')'
          } else {
            typeLan = type + '_' + getLanguage
            valueHtml = data[typeLan]
          }
        } else {
          typeLan = type + '_' + getLanguage
          valueHtml = data[typeLan]
        }
        return valueHtml
      } else if (['address'].includes(type)) {
        typeLan = type + '_' + getLanguage
        return data[typeLan]
      }
    },
    handleSelect: function (key, keyPath) {
      // console.log(key, keyPath)
    },
    // 轮播图左循环
    rotationLeftClick: function () {
      var aImgs = document.querySelectorAll('.container img')
      var aLis = document.querySelectorAll('.rotation-button li')

      // 记录上一张图片的下标
      var lastIndex = this.activeIndex

      // 清除上一张图片的样式
      aImgs[lastIndex].className = ''
      aLis[lastIndex].className = ''

      this.activeIndex--
      if (this.activeIndex < 0) {
        this.activeIndex = aImgs.length - 1
      }
      // 设置当前图片的样式
      aImgs[this.activeIndex].className = 'on'
      aLis[this.activeIndex].className = 'active'
    },
    // 轮播图右循环
    rotationRightClick: function () {
      var aImgs = document.querySelectorAll('.container img')
      var aLis = document.querySelectorAll('.rotation-button li')

      // 记录上一张图片的下标
      var lastIndex = this.activeIndex

      // 清除上一张图片的样式
      if (aImgs.length > 0) {
        aImgs[lastIndex].className = ''
        aLis[lastIndex].className = ''
      } else {
        return false
      }

      this.activeIndex++
      this.activeIndex %= aImgs.length

      // 设置当前图片的样式
      aImgs[this.activeIndex].className = 'on'
      aLis[this.activeIndex].className = 'active'
    },
    // 轮播图点击按钮
    rotationButtonClick: function (index) {
      var aImgs = document.querySelectorAll('.container img')
      var aLis = document.querySelectorAll('.rotation-button li')

      // 记录上一张图片的下标
      var lastIndex = this.activeIndex

      // 清除上一张图片的样式
      aImgs[lastIndex].className = ''
      aLis[lastIndex].className = ''

      this.activeIndex = index

      // 设置当前图片的样式
      aImgs[this.activeIndex].className = 'on'
      aLis[this.activeIndex].className = 'active'
    },
    closepopEven: function (type) {
      if (type === 'dateSearch') {
        this.dateSearch = false
      }
      if (type === 'addrSearch') {
        this.addrSearch = false
        this.$refs.locationSearchMoblie.click()
      }
      if (type === 'personSearch') {
        this.personSearch = false
      }
    },
    getCheckDate: function (val) {
      this.checkDate = val
    },
    getSonPerson: function (val) {
      this.adultNum = val['adult']
      this.childNum = val['child']
      this.roomNum = val['room']
      this.personInfo = val['adult']
      if (val['child'] > 0) {
        this.personInfo = val['adult']
      }
      this.roomInfo = val['room']
      this.selecteds = val['childOld']
    },
    getSonRegion: function (json) {
      this.region = json.region
      this.search_json = {'type': json.type, 'type_id': json.type_id}
      console.log(json)

      // 选择后，日期是否需要打开昨日房
      this.addrDateTime = json.zDateTime
    },
    clickistop (type) {
      this.hotelType = type
      if (type === 'hot') {
        this.istop0 = true
        this.istop1 = false
        this.istop2 = false
        this.listInfo = [
          {id: '1', img: 'https://res.roompai.com/static/img/rotation/photo.jpg', islike: '0', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'},
          {id: '2', img: 'https://res.roompai.com/static/img/rotation/photo1.jpg', islike: '1', hotelname: 'Kingston Suites Hotel Bangkok (SHA Plus+)', location: '老城区, 河内 - 位于市中心', money: '1000'},
          {id: '3', img: 'https://res.roompai.com/static/img/rotation/photo2.jpg', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'},
          {id: '4', img: 'https://res.roompai.com/static/img/rotation/photo3.jpg', islike: '0', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'},
          {id: '5', img: 'https://res.roompai.com/static/img/rotation/photo4.png', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'}
        ]
      } else if (type === 'low') {
        this.istop0 = false
        this.istop1 = true
        this.istop2 = false
        this.listInfo = [
          {id: '1', img: 'https://res.roompai.com/static/img/rotation/photo5.jpg', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '313'},
          {id: '2', img: 'https://res.roompai.com/static/img/rotation/photo4.png', islike: '0', hotelname: 'Kingston Suites Hotel Bangkok (SHA Plus+)', location: '老城区, 河内 - 位于市中心', money: '700'},
          {id: '3', img: 'https://res.roompai.com/static/img/rotation/photo3.jpg', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '1000'},
          {id: '4', img: 'https://res.roompai.com/static/img/rotation/photo2.jpg', islike: '0', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'},
          {id: '5', img: 'https://res.roompai.com/static/img/rotation/photo1.jpg', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'}
        ]
      } else if (type === 'high') {
        this.istop0 = false
        this.istop1 = false
        this.istop2 = true
        this.listInfo = [
          {id: '1', img: 'https://res.roompai.com/static/img/rotation/photo3.jpg', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '452'},
          {id: '2', img: 'https://res.roompai.com/static/img/rotation/photo2.jpg', islike: '1', hotelname: 'Kingston Suites Hotel Bangkok (SHA Plus+)', location: '老城区, 河内 - 位于市中心', money: '1000'},
          {id: '3', img: 'https://res.roompai.com/static/img/rotation/photo1.jpg', islike: '0', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '327'},
          {id: '4', img: 'https://res.roompai.com/static/img/rotation/photo5.jpg', islike: '0', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'},
          {id: '5', img: 'https://res.roompai.com/static/img/rotation/photo4.png', islike: '1', hotelname: 'Ha Noi Re Hostel', location: '老城区, 河内 - 位于市中心', money: '250'}
        ]
      }
    },
    roomAdd () {
      if (this.roomNum < 8) {
        this.roomNum += 1
        this.roomLessDo = true
        this.roomInfo = this.roomNum
        if (this.roomNum > this.adultNum) {
          this.adultNum = this.roomNum
          this.adultLessDo = true
          this.personInfo = this.adultNum
        }
      } else {
        this.roomAddNoDo = true
      }
    },
    roomLess () {
      if (this.roomNum > 1) {
        this.roomNum -= 1
        if (this.roomNum === 1) {
          this.roomLessDo = false
        }
        this.roomInfo = this.roomNum
      }
      if (this.roomNum < 8) {
        this.roomAddNoDo = false
      }
    },
    adultAdd () {
      this.adultNum += 1
      this.adultLessDo = true
      this.personInfo = this.adultNum
    },
    adultLess () {
      if (this.adultNum > 1) {
        this.adultNum -= 1
        if (this.adultNum === 1) {
          this.adultLessDo = false
        }
        this.personInfo = this.adultNum
        if (this.roomNum > this.adultNum) {
          this.roomNum = this.adultNum
          this.roomInfo = this.roomNum
          if (this.roomNum === 1) {
            this.roomLessDo = false
          }
          if (this.roomNum < 8) {
            this.roomAddNoDo = false
          }
        }
      }
    },
    childAdd () {
      if (this.childNum < 10) {
        this.childNum += 1
        this.childLessDo = true
        this.personInfo = this.adultNum
      } else {
        this.childAddNoDo = true
      }
      if (this.childNum === 1) {
        this.showChildInfo = true
      }
      this.selecteds[this.childNum - 1] = '<1'
    },
    childLess () {
      if (this.childNum > 0) {
        if (this.selecteds.length === this.childNum) {
          this.selecteds.pop()
        }
        this.childNum -= 1
        this.personInfo = this.adultNum
        if (this.childNum === 0) {
          this.childLessDo = false
          this.personInfo = this.adultNum
        }
      }
      if (this.roomNum < 8) {
        this.childAddNoDo = false
      }
      if (this.childNum === 0) {
        this.showChildInfo = false
      }
    },
    moblieDateChoice () {
      document.activeElement.blur()
      return false
    },
    querySearch: function (queryString, cb) {
      this.triggerOnFocus = true
      var keywordSearch = sessionStorage.getItem('keywordSearch')
      window.queryCallback = cb
      this.loadAll(queryString, 2)
      // let restaurants = this.restaurants
      // let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      console.log('展示下拉1')

      // 调用 callback 返回建议列表的数据
      if (queryString === '') {
        let restaurants = this.restaurants
        cb(restaurants)
        return false
      }
      console.log('展示下拉2')

      // 内容无变化 不请求接口
      if (queryString !== '' && queryString === keywordSearch) {
        let restaurants = this.restaurants
        cb(restaurants)
        return false
      }
      console.log('展示下拉3')

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let restaurants = this.restaurants
        cb(restaurants)
        console.log('展示下拉4')
      }, 510)
    },
    createFilter (queryString) {
      return (region) => {
        return (region.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
      }
    },
    loadAll: function (keyword, type) {
      this.frameRegionMustDialog = false
      var keywordSearch = sessionStorage.getItem('keywordSearch')

      // 搜索为空不请求接口
      if (type === 2 && keyword === '') {
        let restaurants = localStorage.getItem('restaurants')
        this.restaurants = JSON.parse(restaurants)
        return false
      }
      // 内容无变化 不请求接口
      if (keyword !== '' && keyword === keywordSearch) {
        let restaurants = localStorage.getItem('restaurants')
        this.restaurants = JSON.parse(restaurants)
        return false
      }
      // 选择下拉后不请求接口
      // if (type === undefined) {
      //   return false
      // }

      sessionStorage.setItem('keywordSearch', keyword)
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {'keyword': keyword, 'operation': 'getDestinationList', 'language': this.common.languageSet(this), 'time': time, 'page': 7}
      // 首页初始化，添加风控检查字符.
      if (type === 1) {
        dataJson.homeInit = 1
      }
      var data = this.common.encryptionData(dataJson, this)
      getHotelList(data).then(res => {
        if (res.flag === '200') {
          console.log('请求接口完成')

          this.restaurants = res.data
          localStorage.setItem('restaurants', JSON.stringify(this.restaurants))

          var regionSel = {}
          if (res.data.length > 0) {
            regionSel = {'value_zh': res.data['0']['value_zh'], 'value_en': res.data['0']['value_en'], 'type_id': res.data['0']['type_id'], 'type_data_id': res.data['0']['type_data_id']}
          }
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

          if (window.queryCallback && this.triggerOnFocus) {
            window.queryCallback(res.data)
          }
        } else if (res.flag === '102') {
          // this.$router.push({name: 'notFoundPage', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': 1}, 'obj')
          }
          this.$router.push({name: 'notFoundPage', params: {'querys': newQuerys}})
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    handleRegionSelect (item) {
      this.triggerOnFocus = false
      this.$refs.regionInput.$refs.input.blur = () => {
        console.log(this.$refs.regionInput.$refs.input.value)
      }
      if (this.language === 'zh') {
        this.region = item.value_zh
      } else {
        this.region = item.value_en
      }

      // 保留选择的目的地
      sessionStorage.setItem('regionSel', JSON.stringify(item))
      this.search_json = {'type': item.type_id, 'type_id': item.type_data_id}

      // 选择后，日期是否需要打开昨日房
      this.addrDateTime = item.zDateTime
    },
    searchList () {
      if (this.childNum !== 0) {
        for (var ci = 1; ci <= this.childNum - 1; ci++) {
          if (this.selecteds[ci] === undefined) {
            this.selecteds[ci] = '<1'
          }
        }
      }

      if (this.checkDate[0] === this.checkDate[1]) {
        var startDate = new Date(this.checkDate[0])
        let startY = startDate.getFullYear()
        let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)

        var endDate = new Date(this.checkDate[1])
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }

        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        var endDateD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
        this.checkDate[1] = (endDate.getFullYear()) + '-' + endDateMonth + '-' + endDateD
      }

      this.search_json['start_date'] = this.checkDate[0]
      this.search_json['end_date'] = this.checkDate[1]
      this.search_json['room'] = this.roomNum
      this.search_json['adult'] = this.adultNum
      this.search_json['child'] = this.childNum
      this.search_json['childNums'] = this.selecteds

      // 点击事件触发请求接口录入信息
      var searchButtonData = {
        'checkin_date': this.search_json['start_date'],
        'checkout_date': this.search_json['end_date'],
        'rooms': this.search_json['room'],
        'adults': this.search_json['adult'],
        'childs': this.search_json['child'],
        'babys': this.search_json['childNums']
      }

      if (this.restaurants.length === 0 && this.region !== '') {
        this.noDestinationtDialog = true
        return false
      }

      if (this.restaurants.length === 0 || this.region === '' || this.region === undefined) {
        this.frameRegionMustDialog = true

        searchButtonData['region'] = ''
        this.clickPageAction('search_button', '', searchButtonData)
      } else {
        var restaurantsArr = localStorage.getItem('restaurants')
        this.restaurants = JSON.parse(restaurantsArr)

        // 目的地展示文字
        if (this.restaurants['0']['value_en'].toLowerCase().includes(this.region.toLowerCase()) || this.restaurants['0']['value_zh'].includes(this.region)) {
          this.search_json['type'] = this.restaurants['0']['type_id']
          this.search_json['type_id'] = this.restaurants['0']['type_data_id']
          if (this.language === 'zh') {
            this.region = this.restaurants['0']['value_zh']
          } else {
            this.region = this.restaurants['0']['value_en']
          }

          // 保留选择的目的地
          var regionSel = {'value_zh': this.restaurants['0']['value_zh'], 'value_en': this.restaurants['0']['value_en'], 'type_id': this.restaurants['0']['type_id'], 'type_data_id': this.restaurants['0']['type_data_id']}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
        }

        this.search_json['region'] = this.region
        this.search_json['language'] = this.language
        this.search_json['currency'] = this.currency
        if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
          this.search_json['source'] = this.source
        }

        if (this.conver === 1 || this.conver === '1') {
          this.search_json['conver'] = this.conver
        }

        searchButtonData['region'] = this.search_json['region']
        this.clickPageAction('search_button', '', searchButtonData)

        localStorage.setItem('searchData', JSON.stringify(this.search_json))

        // this.$router.push({name: 'HotelList', query: this.search_json})
        var newQuerys = this.common.linkEncode(this.search_json, 'obj')
        this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
        // this.$router.push({name: 'HotelList', query: { 'region': this.region_select, 'type': this.regions[this.region_select]['type'], 'start_date': this.checkDate[0], 'end_date': this.checkDate[1], 'adult': this.adultNum, 'child': this.childNum, 'room': this.roomNum }})
      }

      document.getElementById('inputButtonPc').blur()
    },
    searchListMobile () {
      if (this.checkDate[0] === this.checkDate[1]) {
        var startDate = new Date(this.checkDate[0])
        let startY = startDate.getFullYear()
        let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)

        var endDate = new Date(this.checkDate[1])
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }

        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        var endDateD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
        this.checkDate[1] = (endDate.getFullYear()) + '-' + endDateMonth + '-' + endDateD
      }

      this.search_json['start_date'] = this.checkDate[0]
      this.search_json['end_date'] = this.checkDate[1]
      this.search_json['room'] = this.roomNum
      this.search_json['adult'] = this.adultNum
      this.search_json['child'] = this.childNum
      this.search_json['childNums'] = this.selecteds

      var homeRegion = this.$refs['homeRegion'].value
      // 点击事件触发请求接口录入信息
      var searchButtonData = {
        'checkin_date': this.search_json['start_date'],
        'checkout_date': this.search_json['end_date'],
        'rooms': this.search_json['room'],
        'adults': this.search_json['adult'],
        'childs': this.search_json['child'],
        'babys': this.search_json['childNums']
      }

      if (homeRegion === '' || homeRegion === undefined) {
        this.frameRegionMustDialog = true
        this.frameRegionMustDialogMobile = true

        searchButtonData['region'] = ''
        this.clickPageAction('search_button', '', searchButtonData)
      } else {
        if (this.search_json['type'] === undefined) {
          this.search_json['type'] = this.restaurants['0']['type_id']
        }
        if (this.search_json['type_id'] === undefined) {
          this.search_json['type_id'] = this.restaurants['0']['type_data_id']
        }
        this.search_json['region'] = this.region
        this.search_json['language'] = this.language
        this.search_json['currency'] = this.currency
        if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
          this.search_json['source'] = this.source
        }
        if (this.conver === 1 || this.conver === '1') {
          this.search_json['conver'] = this.conver
        }
        console.log(this.selecteds)
        console.log(this.search_json)

        searchButtonData['region'] = this.region
        this.clickPageAction('search_button', '', searchButtonData)

        localStorage.setItem('searchData', JSON.stringify(this.search_json))
        localStorage.setItem('showFilter', false)
        localStorage.setItem('showSort', false)
        var newQuerys = this.common.linkEncode(this.search_json, 'obj')
        this.search_json['querys'] = newQuerys
        this.$router.push({name: 'HotelList', params: this.search_json})

        // this.$router.push({name: 'HotelList', query: { 'region': this.region_select, 'start_date': this.checkDate[0], 'end_date': this.checkDate[1], 'adult': this.adultNum, 'child': this.childNum, 'room': this.roomNum }})
      }
    },
    getMyCollect () {
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        return true
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'source': this.source, 'is_login': false, 'pageSize': 5, 'page': 1, 'time': time, 'language': this.common.languageSet(this), 'token': token, 'sessionid': sessionid, 'currency': this.common.currencySet(this)}
      if (this.conver === 1 || this.conver === '1') {
        dataJson = {'source': this.source, 'is_login': false, 'pageSize': 5, 'page': 1, 'time': time, 'language': this.common.languageSet(this), 'token': token, 'sessionid': sessionid, 'currency': this.common.currencySet(this), 'conver': this.conver}
      }
      var data = this.common.encryptionData(dataJson, this)
      // console.log(data)
      myCollect(data).then(res => {
        // console.log(res)
        if (res.flag === '200' && res.data !== '') {
          // localStorage.setItem('token', res.data.token)
          this.myCollectList = res.data.list
          this.resultCurrency = res.data.currency
          this.collectShow = true
        } else {
          this.collectShow = false
        }
      })
    },
    collect (key, islike) {
      var dolike = parseInt(islike) === 1 ? 0 : 1
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': key, 'status': dolike, 'token': token, 'time': time, 'language': this.common.languageSet(this), 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      doCollect(data).then(res => {
        if (res.flag === '200') {
          this.getMyCollect()
        }
      })
    },
    dateSearchShow: function (e) {
      var that = this
      // console.log(this.$refs.hiddenDatePicker)
      // this.$refs.hiddenDatePicker.$emitChange(this.checkDate)
      this.$refs.hiddenDatePicker.$el.click(function (e) {
        this.$emit('pick', that.checkDate)
      })
      // this.$refs.seeMorePictures.style.display = 'block'

      if (this.hotelDateSearchShow === false) {
        this.hotelDateSearchShow = true
      }
    },
    showPerson: function (e) {
      if (this.showPersonInfo === false) {
        this.showPersonInfo = true
      } else {
        this.showPersonInfo = false
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'person-pc') {
        if (this.showPersonInfo === true) {
          this.showPersonInfo = false
        }
      }
      if (node.target.getAttribute('data-index') !== 'date-pc') {
        if (this.hotelDateSearchShow === true) {
          this.hotelDateSearchShow = false
        }
      }
    },
    jumpDetail (hotelid, hotelname, zDateTime) {
      // var date1 = new Date()
      // date1.setDate(date1.getDate() + 1)
      // var date2 = new Date(date1)
      // date2.setDate(date1.getDate() + 1)
      // var start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
      // var end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
      const newdate = new Date(zDateTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]
      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = hotelname
      detailjson['start_date'] = zDateTime
      detailjson['end_date'] = newDateStr
      detailjson['room'] = 1
      detailjson['adult'] = 2
      detailjson['child'] = 0
      detailjson['language'] = this.language
      detailjson['currency'] = this.currency
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        detailjson['source'] = this.source
      }
      if (this.conver === 1 || this.conver === '1') {
        detailjson['conver'] = this.conver
      }
      // this.$router.push({name: 'HotelDetail', query: detailjson})
      var newQuerys = this.common.linkEncode(detailjson, 'obj')
      this.$router.push({name: 'HotelDetail', params: {'querys': newQuerys}})
    },
    updateChildSelect: function (num, e) {
      // this.selecteds[num] = e
      this.selecteds.splice(num, 1, e)
      this.$forceUpdate()
    }
  }
}
</script>
<style type="text/css" scoped>
  body > .el-container {margin-bottom: 40px;}
  .el-container{display:block;}
  .el-main{margin-top:60px;}
  .el-select-dropdown{display:none;}
  .mainMask{position: fixed; top: 0px;left: 0px;width: 100%;height: 100%;background: rgb(0,0,0,0.4);z-index: 2000;}

/* PC */
  .marginnone{margin-right:0px;}
  .location-search-pc{padding:35px 0px;}
  .location-search-moblie{padding: 0px 20px;}
  .list-search{width: 100%;height: 64px;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;background-color: rgba(79, 76, 76, 1);margin: 0 auto;line-height: 64px;}
  .location-search{margin: 0 auto;}
  .list-content{margin: 15px auto;}
  /* 目的地 */
  .input-region{width: 361px; height: 48px;}
  .location-search .hotellist-region{width:32.73%;/*vertical-align: top;*/}
  .hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 20px;background-position: 12px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  /*,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus*/
  .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
  .hotellist-region /deep/ .el-input__inner{padding: 0 60px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 20px;background-position: 15px center;}
  .location-search-moblie .hotellist-region /deep/ .el-input__inner{padding: 0 40px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 20px;background-position: 10px center;}
  .hotellist-region /deep/ .el-popover--plain{width:100%;padding:0px;color: #FF6B6D;top: -33px;font-size:12px;height: 28px;line-height: 28px;z-index: 2001;text-align:center;}
  .el-autocomplete{width:100%;}
  /deep/ .my-autocomplete{width: 189%!important;left: 0px!important;}
  /deep/ .el-autocomplete-suggestion li{padding:0px;}
  /deep/ .el-autocomplete-suggestion li:hover{color: rgb(83,146,249);}
  .my-autocomplete .name {height:25px;text-overflow: ellipsis;overflow: hidden;font-weight: 650;}
  .my-autocomplete .addr {height:25px;font-weight: 100;}
  .my-autocomplete .highlighted .addr {color: #ddd;}
  .my-autocomplete .locationClass{background: url(https://res.roompai.com/static/img/home/input-region.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  /deep/ .el-autocomplete-suggestion li:hover .locationClass{background: url(https://www.roompai.com/static/img/home/input-region-hover.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  .my-autocomplete .hotelClass{background: url(https://res.roompai.com/static/img/home/hotel.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  /deep/ .el-autocomplete-suggestion li:hover .hotelClass{background: url(https://res.roompai.com/static/img/home/hotel-hover.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  /deep/ .el-popper[x-placement^=bottom] .popper__arrow{left: 56px!important;}
  .el-container /deep/ .el-dialog .el-dialog__header{text-align:center;}

  /* 日期 */
  .hotellist-date-all{height:100%;width:28.55%;display:inline-block;vertical-align: top;cursor:pointer;position: relative;}
  .hotellist-date{padding: 0px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-date .hotellist-date-start{float:left;width: 37%;height: 100%;/*text-indent: 0.5rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-start-left{width: 35%;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-date{width: 100%;height: 50%;line-height: 28px;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-week{width: 100%;height: 50%;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date .hotellist-date-line{float:left;width:6%;height: 50%;line-height: 40px;}
  .hotellist-date .hotellist-date-line img{width: 65%;height: 100%;}
  .hotellist-date .hotellist-date-end{float:right;width: 38%;height: 100%;/*text-indent: 1rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-date{width: 100%;height: 50%;line-height: 28px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-week{width: 100%;height: 50%;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date-all .hotellist-date-time-show{position:absolute;left:0px;top:0px;margin-top: 6px;}
  .el-range-editor.el-input__inner{display:inline-block;}
  .el-date-editor--daterange.el-input__inner{ width:100%;}
  .input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 0px center;}
  /deep/ .hotellist-date .el-range-separator{display:none!important;}
  .hotellist-date .el-range__icon{margin-left:0px;}
  .hotellist-date-all .hotellist-date-show{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}

  /* */
  .hotellist-date-mobile{width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .date-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;margin: 0em;background-color:rgba(255,255,255,1);width: 100%; height: 48px;opacity:1; cursor: pointer;font-size: 12px;}
  .date-inner .date-inner-start{width: 49%;height: 100%;float:left;overflow:hidden;}
  .date-inner .date-inner-division{border-right: solid 1px #797979;width: 1%;height: 100%;line-height: 45px;float:left;overflow:hidden}
  .date-inner .date-inner-end{width: 49%;height: 100%;line-height: 45px;float:left;overflow:hidden;}
  .date-inner .date-inner-check-img{width: 40px;height: 100%;background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 10px center;float:left;}
  .date-inner .date-inner-check-info{height: 100%;width:55%;float:left;}
  .date-inner .date-inner-check-str{width: 100%;height: 50%;line-height: 30px;}
  .date-inner .date-inner-check-date{width: 100%;height: 50%;line-height: 17px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}

  /* 入住人 */
  .person-inner{text-align:left;border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 10px center;padding: 0px 40px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
  .inphotellistut-person .person-inner:hover{border-color:rgb(252, 210, 5, 1);}
  /* .el-select-dropdown{display:none;} */
  .personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff;}
  .personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
  .personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
  .personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
  .personnum{position: relative;display: inline-block;width: 100%;line-height: 38px;text-align: center;}
  .personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;}
  .personnum .personSpan{border: none;outline: none;width: 20px;height: 32px;color: #409EFF;font-weight: 400;font-size: 18px;margin-right: 7px;vertical-align: top;}
  .personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
  .personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
  .personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
  .personnum span{display:inline-block;}
  .personnum input{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
  .personnum input:focus{border:0;outline:none;width:20px;height:32px;}
  .spantext{color:#999999; font-size: 14px;}
  .select-person{display:inline-block; width:21.82%;position:relative;vertical-align: top;}
  .showPersonBorder{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
  .showPersonBorder:hover{border-color:rgb(252, 210, 5, 1);}
  .location-search-pc .personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;height:50%;line-height:28px;white-space: nowrap;overflow: hidden;}
  .roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;display:block;height:50%;line-height:20px;}
  .childinfo .el-select-dropdown,.el-select-dropdown{display:block;}
  .selectOld{width: 40%;float: left;margin-left: 5%;}
  /* 加减成人 */
  .personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
  .personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
  /* 入住人选择 */
  .personInfo{border-width: 0px;position: absolute;width: 100%;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); color: #999999;font-size: 14px;line-height: 50px;top: 60px;}
  .location-search-moblie .personText{/*font-weight: 650;*/ font-size:14px;color: #4F4C4C;display:block;height:100%;line-height:48px;white-space: nowrap;overflow: hidden;}
  .location-search-moblie .personText span{padding:0px;}
  .location-search-moblie .el-input__suffix-inner{height:100%;}

  /* 字体 */
  .location-search-moblie .home-search-text{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-size:14px;}

  /* 搜索 */
  .hotellist_button{width:12%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
  .hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
  /* 按钮 */
  .input_button_pc{vertical-align: top;}
  /* 搜索条件 结束 */
  /* 搜索 */
  .hotellist_button{width:12%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
  .hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
  /deep/ .selectOld .el-input--suffix .el-input__inner{text-align: center;}

/* mobile */
  /* 组件 */
  .location-search-moblie .hotellist-person{height:48px;}
  .home-collection-center .home-collection-mobile .row-col /deep/ .el-card__body{height:90px!important;}
  .el-container /deep/ .no-search-dialog{width: 90%!important;margin-top:40vh!important;}
  .el-container /deep/ .el-dialog__title{font-size:14px!important;}
  .nogoto-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
  .nogoto-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}

/*响应式*/
  @charset "UTF-8";

  @media only screen and (max-width:390px){
    header .header-middle {
        width:100%;
        padding: 0px 10px;
    }
    /* home */
    /*.home-center{height:300px;}*/
    .home-search-frame{top:180px;width:95%;}
    .home-collection-center{width:90%;}
    .home-search-frame .el-input, .select-person, .input_button{width:100%;}
    .home-search-frame .date-inner .date-inner-check-info{width:66%;}
    .home-search-frame .el-date-editor{width:100%;}
    /* 搜索 */
    .home-search-frame .location-search-pc{display:none;}
    .home-search-frame .location-search-moblie{width:90%; padding: 0px 5px;}
    /* 收集 */
    .home-collection .home-collection-pc{display:none}
    .home-collection .home-collection-mobile{width: 95%;margin: 0 auto;}
    .home-collection .home-collection-center{width:100%;}
    .home-collection .home-collection-center h3{text-indent: 10px;}
    /* 背景样式 */
    .home-center .container-pc{display:none;}
    .home-center .container-mobile{}

    .home-slogan{font-size:26px;}
    .home-slogan-one{top:60px;right:94px;}
    .home-slogan-two{top:100px;padding-right: 0px;right:1px;}
    .left-logo .img{display:none;}
    .left-logo .img-mini {display:block;}
    .header-login{display:none;}
    .header-mini-menu{display:block;}
    .home-slogan-search{width:100%;}

    /* 首页收藏 */
    .home-collection-center .row-col{width: 100%;margin-bottom: 10px;}
    /* 底部 */
    .footer .contact-mode{width:100%;text-align: center;}
    .footer .contact-half{width:100%;font-size:1px;height:auto;}
    .footer .contact-phone{float:left;}
  }

  @media only screen and (min-width:390px) and (max-width:490px){
    header .header-middle {
        width:100%;
        padding: 0px 10px;
    }
    /* home */
    /*.home-center{height:300px;}*/
    .home-search-frame{top:180px;width:90%;}
    .home-collection-center{width:90%;}
    .home-search-frame .el-input, .select-person, .input_button{width:100%;}
    .home-search-frame .el-date-editor{width:100%;}
    /* 搜索 */
    .home-search-frame .location-search-pc{display:none;}
    .home-search-frame .location-search-moblie{}
    /* 收集 */
    .home-collection .home-collection-pc{display:none}
    .home-collection .home-collection-mobile{width: 95%;margin: 0 auto;}
    .home-collection .home-collection-center{width:100%;}
    .home-collection .home-collection-center h3{text-indent: 10px;}
    /* 背景样式 */
    .home-center .container-pc{display:none;}
    .home-center .container-mobile{}

    .home-slogan{font-size:26px;}
    .home-slogan-one{top:60px;right:124px;}
    .home-slogan-two{top:100px;padding-right: 0px;right:1px;}
    .left-logo .img{display:none;}
    .left-logo .img-mini {display:block;}
    .header-login{display:none;}
    .header-mini-menu{display:block;}
    .home-slogan-search{width:100%;}

    /* 首页收藏 */
    .home-collection-center .row-col{width: 100%;margin-bottom: 10px;}

    /* 底部 */
    .footer .contact-mode{width:auto;}
    .footer .contact-half{width:auto;}
  }

  @media only screen and (min-width:490px) and (max-width:768px){
    header .header-middle {
        width:100%;
        padding: 0px 10px;
    }
    /* home */
    /*.home-center{height:300px;}*/
    .home-search-frame{top:180px;width:90%;}
    .home-collection-center{width:90%;}
    .home-search-frame .el-input, .select-person, .input_button{width:100%;}
    .home-search-frame .el-date-editor{width:100%;}
    /* 搜索 */
    .home-search-frame .location-search-pc{display:none;}
    .home-search-frame .location-search-moblie{}
    /* 收集 */
    .home-collection .home-collection-pc{display:none}
    .home-collection .home-collection-mobile{width: 95%;margin: 0 auto;}
    .home-collection .home-collection-center{width:100%;}
    .home-collection .home-collection-center h3{text-indent: 10px;}
    /* 背景样式 */
    .home-center .container-pc{display:none;}
    .home-center .container-mobile{}

    .el-date-range-picker{z-index:-100;}

    .home-slogan{font-size:26px;}
    .home-slogan-one{top:60px;right:120px;}
    .home-slogan-two{top:100px;padding-right: 0px;right:1px;}
    .left-logo .img{display:none;}
    .left-logo .img-mini {display:block;}
    .header-login{display:none;}
    .header-mini-menu{display:block;}
    .home-slogan-search{width:100%;}

    /* 首页收藏 */
    .home-collection-center .row-col{width: 100%;margin-bottom: 10px;}

    /* 底部 */
    .footer .contact-mode{width:95%;}
    .footer .contact-half{width:auto;}
  }

  @media only screen and (min-width:768px) and (max-width:992px){
    header .header-middle {
        width:100%;
        padding: 0px 10px;
    }
    /* home */
    /*.home-center{height:350px;}*/
    .home-search-frame{top:180px;width:90%;}
    .home-collection-center{width:90%;}

    /* 搜索 */
    .home-search-frame .el-input, .select-person, .input_button{width:100%;}
    .home-search-frame .el-date-editor{width:100%;}
    .home-search-frame .location-search-pc{display:none;}
    .home-search-frame .location-search-moblie{}

    /* 收集 */
    .home-collection .home-collection-pc{display:none}
    .home-collection .home-collection-mobile{width: 95%;margin: 0 auto;}
    .home-collection .home-collection-center{width:100%;}
    .home-collection .home-collection-center h3{text-indent: 10px;}

    /* 背景样式 */
    .home-center .container-pc{display:none;}
    .home-center .container-mobile{display:block;}

    .home-slogan{font-size:25px;}
    .home-slogan-one{top:60px;right:120px;}
    .home-slogan-two{top:100px;padding-right: 0px;right: 1px;}
    .home-slogan-search{width:100%;}
    /* 首页收藏 */
    .home-collection-center .row-col{width: 100%;margin-bottom: 10px;}

    /* 底部 */
    .footer .contact-mode{width:95%;}
    .footer .contact-half{width:auto;}
  }

  @media only screen and (min-width:992px) and (max-width:1200px){
    header .header-middle {
        width:100%;
        padding: 0px 10px;
    }
    /* home */
    /*.home-center{height:400px;}*/
    .home-search-frame{top:260px;}
    .home-collection-center{width:90%;}

    /* 搜索 */
    .home-search-frame .location-search-pc{}
    .home-search-frame .location-search-moblie{display:none;}

    /* 收集 */
    .home-collection .home-collection-pc{}
    .home-collection .home-collection-mobile{display:none}
    /* 背景样式 */
    .home-center .container-pc{display:block;}
    .home-center .container-mobile{display:none;}

    .home-slogan{font-size:30px;}
    .home-slogan-one{top: 120px;}
    .home-slogan-two{top: 150px;padding-right: 0px;right:200px;}
    .home-slogan-search{width:100%;}

    /* 首页收藏 */
    .home-collection-center .row-col{width: 33%;margin-bottom: 10px;}

    /* 底部 */
    .footer .contact-mode{width:95%;}
    .footer .contact-half{width:auto;}
  }

  @media only screen and (min-width:1200px) and (max-width:1400px) {
    header .header-middle {
        width: 100%;
        padding: 0px 10px;
    }
    /* home */
    .home-search-frame{top:210px;}
    /* 搜索 */
    .home-search-frame .location-search-pc{}
    .home-search-frame .location-search-moblie{display:none;}

    /* 收集 */
    .home-collection .home-collection-pc{}
    .home-collection .home-collection-mobile{display:none}
    /* 背景样式 */
    .home-center .container-pc{display:block;}
    .home-center .container-mobile{display:none;}

    .home-slogan{font-size:35px;}
    .home-slogan-one{top: 70px;}
    .home-slogan-two{top: 100px; padding-right: 0px;right: 200px;}
    .home-slogan-search{width:100%;}

    /* 底部 */
    .footer .contact-half{width:auto;}
  }

  @media only screen and (min-width:1400px) and (max-width:1610px) {
    header .header-middle {
        width: 100%;
        padding: 0px 10px;
    }

    .home-search-frame{width:1100px;}
    /* 搜索 */
    .home-search-frame .location-search-pc{}
    .home-search-frame .location-search-moblie{display:none;}

    /* 收集 */
    .home-collection .home-collection-pc{}
    .home-collection .home-collection-mobile{display:none}

    /* 背景样式 */
    .home-center .container-pc{display:block;}
    .home-center .container-mobile{display:none;}
  }

  @media only screen and (min-width:1610px) and (max-width:1920px) {
    header .header-middle {
        width: 100%;
        padding: 0px 32px;
    }
    .home-center{height: 1210px;}

    .home-search-frame{width: 1100px;}
    /* 搜索 */
    .home-search-frame .location-search-pc{}
    .home-search-frame .location-search-moblie{display:none;}

    /* 收集 */
    .home-collection .home-collection-pc{}
    .home-collection .home-collection-mobile{display:none}

    /* 背景样式 */
    .home-center .container-pc{display:block;}
    .home-center .container-mobile{display:none;}
  }

  @media only screen and (min-width:1920px) {
    header .header-middle {
        width: 100%;
        padding: 0px 32px;
    }

    .home-center{/*height: 1210px;*/height:100vh;}
    .home-search-frame{width:1100px;}
    /* 搜索 */
    .home-search-frame .location-search-pc{}
    .home-search-frame .location-search-moblie{display:none;}

    /* 收集 */
    .home-collection .home-collection-pc{}
    .home-collection .home-collection-mobile{display:none}

    /* 背景样式 */
    .home-center .container-pc{display:block;}
    .home-center .container-mobile{display:none;}
  }
</style>
<style lang="css">
/* .el-tooltip__popper{max-width:185px !important;} */
</style>



// WEBPACK FOOTER //
// src/components/Home.vue